import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const nav = useNavigate();
    const location = useLocation();
    const { refresh } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        (async () => {
            const hash = window.location.hash || "";
            const m = /session_id=([^&]+)/.exec(hash);
            if (!m) {
                nav("/login", { replace: true });
                return;
            }
            const session_id = decodeURIComponent(m[1]);
            try {
                const { data } = await api.post("/auth/google/session", { session_id });
                if (data.token) localStorage.setItem("s2s_token", data.token);
                // Clear hash from URL
                window.history.replaceState(
                    null,
                    "",
                    window.location.pathname + window.location.search
                );
                await refresh();
                nav(data.role === "admin" ? "/admin" : "/dashboard", { replace: true });
            } catch (e) {
                if (process.env.NODE_ENV === "development") {
                    // eslint-disable-next-line no-console
                    console.error("Google auth failed", formatApiError(e));
                }
                nav("/login?google_error=1", { replace: true });
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="min-h-[60vh] flex items-center justify-center text-[#a3a3a3] text-sm tracking-widest uppercase">
            Completing Google sign-in…
        </div>
    );
}
